import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, withModifiers as _withModifiers, withKeys as _withKeys, unref as _unref } from "vue"
import _imports_0 from '@/assets/evo.png'
import _imports_1 from '@/assets/assistant.png'


const _hoisted_1 = { class: "card shadow-elevation hover-shadow-elevation-2 bg-white relative" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-medium" }, "Evo Assistant", -1)
const _hoisted_4 = { class: "flex flex-col items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex space-x-2 items-center relative mt-8 mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-20 h-auto mx-auto"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "flex rounded-full p-2 absolute top-0 right-0 z-10 transform translate-x-2/3 -translate-y-1/2 shadow-elevation",
    style: {"background":"#e8d6fb"}
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      class: "w-10 h-auto",
      style: {"transform":"rotate(12deg)"}
    })
  ])
], -1)
const _hoisted_6 = {
  key: 0,
  class: "mt-2 flex flex-col space-y-2 align-center items-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-muted" }, "Per iniziare, prova a chiedermi:", -1)
const _hoisted_8 = { class: "flex flex-col space-y-1" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "flex justify-start w-full" }
const _hoisted_11 = {
  key: 0,
  class: "mt-1 ml-2"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 1,
  class: "flex justify-end"
}
const _hoisted_15 = { class: "bg-primary text-white p-2 rounded-lg" }
const _hoisted_16 = {
  key: 0,
  class: "relative my-2 card bg-primary text-onPrimary"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"14px !important"},
  class: "material-icons-outlined text-onPrimary"
}, " close ", -1)
const _hoisted_18 = { class: "flex items-center space-x-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined icon-light" }, " send ", -1)
const _hoisted_20 = {
  key: 1,
  class: "text-xs text-muted mt-2"
}
const _hoisted_21 = { class: "text-xs text-muted mt-2" }

import axios from "axios";
import { computed, onMounted, ref, watch, nextTick } from "vue";
import { useMainStore } from "../../stores/mainStore";
import { useRouter } from "vue-router";
import { Conversation } from "../../models/ai";
import TextEditor from "../ui/TextEditor.vue";
import Spinner from "../ui/Spinner.vue";
import ProcessedTextFragment from "../ui/ProcessedTextFragment.vue";
import { useMetaStore } from "../../stores/metaStore";
import Btn from "../ui/Btn.vue";
import { EventTemplate, EventTemplateRuleType, getBlankPractice } from "../../models";
import { EventSourcePolyfill as EventSource } from "event-source-polyfill";
import { getTranslatedString as _ } from "../../i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatbotUi',
  props: {
    courseId: null
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props as { courseId?: string };

const mainStore = useMainStore();
const metaStore = useMetaStore();
const router = useRouter();

const resolvedCourseId = computed(
	() => props.courseId ?? (router.currentRoute.value.params.courseId as string),
);
const currentCourse = computed(
	() =>
		mainStore.getCourseById(resolvedCourseId.value) ??
		({ id: resolvedCourseId.value } as any),
);

// const props = defineProps({
// 	conversationId: {
// 		type: String,
// 		required: true,
// 	},
// });



const conversation = ref<Conversation | null>(null);
const loading = ref(false);
const generatingResponse = ref(false);

const showSuggestPracticeBanner = ref(false);
const suggestedPracticeTags = ref<string[]>([]);
const startSuggestedPractice = async () => {
	const eventPayload = {
		...getBlankPractice(),
		template: {
			id: "",
			rules: suggestedPracticeTags.value
				.map(
					tag => (
						console.log(
							"searching tag",
							tag,
							mainStore.tags.map(t => t.name.toLocaleLowerCase()),
						),
						{
							weight: 1,
							rule_type: EventTemplateRuleType.TAG_BASED,
							clauses: [
								{
									tags: [
										{
											id: mainStore.tags.find(
												t => t.name.toLocaleLowerCase() === tag.toLocaleLowerCase(),
											)?.id,
										},
									],
								},
							],
							amount: 1,
						}
					),
				)
				.filter(r => r.clauses?.[0]?.tags[0]?.id),
		} as any as EventTemplate,
	};
	const newPracticeEvent = await mainStore.createEvent({
		courseId: currentCourse.value.id,
		event: eventPayload,
	});

	router.push({
		name: "PracticeParticipationPage",
		params: {
			examId: newPracticeEvent.id,
		},
	});

	console.log(newPracticeEvent);
};

const rateLimit = ref<string | null>(null);
const rateLimitParsed = computed(() => {
	if (!rateLimit.value) {
		return null;
	}
	return rateLimit.value.split("/");
});

const onSendConversationStarter = (starter: string) => {
	messageContent.value = starter;
	sendMessage({ shiftKey: false, key: "Enter" } as any);
};

const fns = {
	suggest_practice_session: async (args: any) => {
		console.log("args", args);
		showSuggestPracticeBanner.value = true;
		suggestedPracticeTags.value = args.tags;
	},
};

const messageContent = ref("");
const sendMessage = async event => {
	if (generatingResponse.value) {
		return;
	}

	if (event.shiftKey && event.key === "Enter") {
		messageContent.value += "\n";
		return;
	}

	if (messageContent.value.trim() === "") {
		return;
	}

	const content = messageContent.value;
	messageContent.value = "";

	conversation.value?.messages.push({
		id: Math.random().toString(),
		text: content,
		message_type: "user",
		created: new Date().toISOString(),
		data: {},
	});

	try {
		generatingResponse.value = true;
		const assistantMessage = {
			id: Math.random().toString(),
			text: "",
			message_type: "assistant",
			created: new Date().toISOString(),
			data: {},
		};
		conversation.value?.messages.push(assistantMessage);

		const eventSource = new EventSource(
			`${axios.defaults.baseURL}/courses/${
				currentCourse.value.id
			}/assistant-conversations/${
				conversation.value?.id
			}/message/?message=${encodeURIComponent(content)}`,
			{
				headers: {
					Authorization: `Bearer ${metaStore.token}`,
				},
			},
		);

		console.log("event source", eventSource);
		eventSource.onerror = error => handleSendMessageError(error);
		eventSource.onmessage = async event => {
			console.log("event", event);
			if (event.data === "[DONE]") {
				eventSource.close();
				generatingResponse.value = false;
				return;
			}
			const data = JSON.parse(event.data);
			const type = data.type;
			console.log("data", data, data.object);

			if (type === "message_delta") {
				const {
					data: { text, annotations },
				} = data;
				assistantMessage.text += text;
				assistantMessage.data.annotations = annotations;
				conversation.value?.messages.splice(conversation.value.messages.length - 1, 1);
				conversation.value?.messages.push(assistantMessage);
			} else if (type === "function_call") {
				const {
					data: { name, arguments: args },
				} = data;
				if (fns[name]) {
					await fns[name](args);
				}
			} else {
				console.log("!!! DATA", data);
			}
		};
	} catch (error) {
		handleSendMessageError(error);
	}
};

const handleSendMessageError = error => {
	console.error("Error sending message:", error);
	generatingResponse.value = false;
	conversation.value?.messages.splice(conversation.value.messages.length - 1, 1);
	conversation.value?.messages.push({
		id: Math.random().toString(),
		text: error.status === 429 ? _("misc.rate_limit_reached") : _("misc.error_occurred"),
		message_type: "assistant",
		created: new Date().toISOString(),
		data: { error: true },
	});
};

const scrollableFragment = ref<HTMLElement | null>(null);
const scrollToBottom = () => {
	nextTick(() =>
		scrollableFragment.value?.scrollTo({
			top: scrollableFragment.value.scrollHeight,
		}),
	);
};

const triggerTexRender = () => {
	const metaStore = useMetaStore();
	metaStore.dirtyTex = true;
};

const formatMessage = (message: string, data: Record<string, unknown>) => {
	let formatted = message
		.replace(/\n/g, "<br>")
		.replace(/<h1>([^<]+)<\/h1>/g, "<strong class='text-xl font-medium'>$1</strong>")
		.replace(/<h2>([^<]+)<\/h2>/g, "<strong class='text-xl font-medium'>$1</strong>")
		.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
		.replace(/\*([^*]+)\*/g, "<em>$1</em>")
		.replace(/```([^`]+)```/g, "<code>$1</code>")
		.replace(/`([^`]+)`/g, "<code>$1</code>");

	// replace annotations by [index]
	const annotations = data.annotations;
	if (annotations) {
		Object.entries(annotations).forEach(([text], index) => {
			formatted = formatted.replace(text, ` [${index}]`);
		});
	}
	return formatted;
};

onMounted(async () => {
	loading.value = true;
	const {
		data: { rate_limit, ...data },
	} = await axios.post(`/courses/${currentCourse.value.id}/assistant-conversations/`);
	rateLimit.value = rate_limit;
	conversation.value = data;
	loading.value = false;
});

watch(conversation, scrollToBottom, { immediate: true, deep: true });
watch(conversation, triggerTexRender, { immediate: true, deep: true });
watch(
	conversation,
	() => {
		scrollToBottom();
		triggerTexRender();
	},
	{ immediate: true, deep: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createBlock(Spinner, {
          key: 0,
          class: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2",
          variant: 'primary',
          size: 'xl'
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(Btn, {
        class: "",
        variant: 'icon',
        outline: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: "material-icons-outlined",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, " close ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      ref_key: "scrollableFragment",
      ref: scrollableFragment,
      style: {"max-height":"60vh","min-height":"60vh"},
      class: "flex flex-col overflow-y-auto"
    }, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (
						conversation.value?.conversation_starters &&
						conversation.value?.conversation_starters.length > 0 &&
						conversation.value?.messages.length === 0
					)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conversation.value?.conversation_starters, (starter, index) => {
                  return (_openBlock(), _createBlock(Btn, {
                    onClick: ($event: any) => (onSendConversationStarter(starter)),
                    variant: 'transparent',
                    key: index,
                    class: "bg-light p-2 rounded-lg"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(starter), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conversation.value?.messages, (message, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: message.id,
          class: _normalizeClass(
					index < (conversation.value?.messages?.length ?? 0) - 1
						? 'my-1 assistant-message'
						: 'mt-1 mb-4 assistant-message'
				)
        }, [
          (message.message_type === 'assistant')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (message.text)
                    ? (_openBlock(), _createBlock(ProcessedTextFragment, {
                        key: 0,
                        style: {"white-space":"pre-line !important"},
                        value: formatMessage(message.text, message.data),
                        class: _normalizeClass([
								'p-2 rounded-lg',
								message.data.error ? 'text-danger-dark bg-danger-light' : 'bg-gray-50',
							])
                      }, null, 8, ["value", "class"]))
                    : _createCommentVNode("", true),
                  (index === conversation.value?.messages.length - 1 && generatingResponse.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass([
								'w-2 h-2 rounded-full animate-ping bg-primary-light mt-auto',
								!!message.text ? '-ml-6 mb-2' : 'ml-2 mb-1',
							])
                      }, null, 2))
                    : _createCommentVNode("", true)
                ]),
                (
							message.data.annotations &&
							Object.entries(message.data.annotations).length > 0
						)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("h5", null, _toDisplayString(_ctx.$t("misc.related_study_material")), 1),
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(
									message.data.annotations,
								), ([text, annotation], index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: text,
                            class: "text-sm text-muted"
                          }, [
                            (annotation.url)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: annotation.url,
                                  target: "_blank",
                                  class: "text-primary hover:underline"
                                }, " [" + _toDisplayString(index) + "] " + _toDisplayString(annotation.filename), 9, _hoisted_12))
                              : (_openBlock(), _createElementBlock("span", _hoisted_13, " [" + _toDisplayString(index) + "] " + _toDisplayString(annotation.filename), 1))
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(message.text), 1)
              ]))
        ], 2))
      }), 128))
    ], 512),
    _createVNode(_Transition, { name: "quick-bounce" }, {
      default: _withCtx(() => [
        (showSuggestPracticeBanner.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createTextVNode(" Vuoi esercitarti su questi argomenti? "),
              _createVNode(Btn, { onClick: startSuggestedPractice }, {
                default: _withCtx(() => [
                  _createTextVNode("Inizia")
                ]),
                _: 1
              }),
              _createVNode(Btn, {
                style: {"position":"absolute"},
                class: "top-1 right-1",
                size: 'xs',
                variant: 'icon',
                outline: true,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showSuggestPracticeBanner.value = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(TextEditor, {
        onKeydown: _withKeys(_withModifiers(sendMessage, ["prevent"]), ["enter"]),
        modelValue: messageContent.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((messageContent).value = $event)),
        class: "w-full",
        "force-base-editor": true,
        tall: false,
        "base-editor-rows": 1,
        "base-editor-resizable": false
      }, null, 8, ["onKeydown", "modelValue"]),
      _createVNode(Btn, {
        variant: 'icon',
        outline: true,
        disabled: generatingResponse.value,
        onClick: sendMessage
      }, {
        default: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    (rateLimit.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t("misc.you_can_send")) + " " + _toDisplayString(_unref(rateLimitParsed)[0]) + " " + _toDisplayString(_ctx.$t("misc.messages")) + " " + _toDisplayString(_ctx.$t(`misc.per_${_unref(rateLimitParsed)[1]}`)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("assistant.disclaimer")), 1)
  ]))
}
}

})